<template>
  <div>
  <div class="classify_nav">
    <div class="classify_nav_content" id = "nav_scroll">
      <div class="classify_nav_ele_wrapper" >
        <span class="classify_nav_ele" :class="tabIndex==0?'now':''" @click="classifyGoods('16,30',0)">精选</span>
        <span class="classify_nav_ele" :class="tabIndex==index+1?'now':''"   v-for="(catalogMainList,index) in catalogList"  @click="classifyGoods(catalogMainList.goodsCat,index+1)">{{catalogMainList.catalog.slice(0,2)}}</span>
      </div>
    </div>
    <div class="classify_nav_all">
      <span class="icon icon-classify cfff" @click="navShow"></span>
    </div>

  </div>

  <mt-popup v-model="navShowFlag"  position="top" modal="true" closeOnClickModal="true" class="pop_nav_all" >
      <div>
        <ul class="catalog_wrapper">
          <li v-for="(catalogList,index) in catalogList"  class="catalog_cell" :key="catalogList.catalogList" @click="classifyGoods(catalogList.goodsCat,index+1)" >
{{catalogList.catalog}}
          </li>
        </ul>
      </div>

  </mt-popup>
  </div>
</template>
<script type = "text/ecamscript-6">
import Vue from 'vue'
import { Popup } from 'mint-ui'
Vue.component(Popup.name, Popup);
import $ from "jquery"
import catalogList from "../../configFile/catalog/catalog.json"
  export default {
    name:"topNav",
    data() {
      return{
        navShowFlag:false,
        catalogList:catalogList.catalogListArray,
        tabIndex:0

      }
    },
    methods:{
      navShow:function(){
        this.navShowFlag = !this.navShowFlag;
      },
      classifyGoods:function(param1,param2){
        this.navShowFlag = false
        this.tabIndex = param2
        //$(".").scrollLeft(100)''
        if(param2-3>0){
          //$("#nav_scroll").scrollLeft((param2-3)*$(".classify_nav_ele").width())
          $("#nav_scroll").animate({scrollLeft:(param2-3)*$(".classify_nav_ele").width()}, 500)
        }
        this.$emit("listenClassify",param1)
      }
    },
  }
</script>
<style lang="stylus" >
  .classify_nav
    width:100%
    display:flex
    height: 80px
    line-height:78px
    background: linear-gradient(to right, #ff0026, #ff6f25)
    position:relative
    overflow:hidden
    .classify_nav_content
      flex:0 0 690px
      white-space: nowrap
      height: 120px
      overflow-x:auto
      overflow-y:hidden
      .classify_nav_ele_wrapper
        display:flex
        white-space: nowrap
        height: 80px
        .classify_nav_ele
          flex:0 0 115px
          width: 115px
          height: 75px
          line-height: 75px
          display: inline-block
          font-size: 28px
          color: #fff
          text-align:center
          &.now
            border-bottom:5px solid #fff
    .classify_nav_all
      flex: 0 0 60px
      text-align: left
      color: #fff
      font-size:28px
  .catalog_wrapper
    background:#fff
    padding:30px
    .catalog_cell
      background:#f2f2f2
      display:inline-block
      padding:20px 30px
      border-radius:10px
      font-size:28px
      margin:10px
  .pop_nav_all
    width:100%
    top:80px



</style>



// WEBPACK FOOTER //
// src/components/common/topNav.vue